export default __webpack_public_path__ + "static/media/Voiteq.f4c6729b.png";